<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M384 160C384 107 427 64 480 64C533 64 576 107 576 160L576 208C576 216.8 583.2 224 592 224C600.8 224 608 216.8 608 208L608 160C608 89.3 550.7 32 480 32C409.3 32 352 89.3 352 160L352 224L192 224C156.7 224 128 252.7 128 288L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 288C512 252.7 483.3 224 448 224L384 224L384 160zM192 256L448 256C465.7 256 480 270.3 480 288L480 512C480 529.7 465.7 544 448 544L192 544C174.3 544 160 529.7 160 512L160 288C160 270.3 174.3 256 192 256z"
      fill="currentColor"
    />
  </svg>
</template>
